// Mock Auth0 wrapper for local development
import React, { useState, useEffect, useContext } from "react";

export const Auth0Context = React.createContext();
export const useAuth0 = () => useContext(Auth0Context);

export const Auth0Provider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [loading, setLoading] = useState(false);
  const [team, setTeam] = useState([]);

  // Mock user object - customize as needed
  const [user] = useState({
    email: "dev@localhost.com",
    name: "Local Dev User",
    nickname: "dev",
    picture: "https://via.placeholder.com/150",
    sub: "google-oauth2|123456789",
    id: "123456789",
    "https://sow.thatsnice.com/roles": ["admin", "super-admin"], // Add roles you need
  });

  useEffect(() => {
    console.log("🔓 Mock Auth0 - Bypassing authentication for local development");
  }, []);

  return (
    <Auth0Context.Provider
      value={{
        isAuthenticated,
        user,
        loading,
        popupOpen: false,
        loginWithPopup: async () => console.log("Mock login"),
        handleRedirectCallback: async () => {},
        getIdTokenClaims: async () => ({ __raw: "mock-token" }),
        loginWithRedirect: async () => console.log("Mock redirect login"),
        getTokenSilently: async () => "mock-token",
        getTokenWithPopup: async () => "mock-token",
        logout: () => console.log("Mock logout"),
        team,
        setTeam,
      }}
    >
      {children}
    </Auth0Context.Provider>
  );
};
